import { createStore, createLogger } from 'vuex'
import consumer from './modules/Consumer'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    consumer
  },
  plugins: debug ? [createLogger()] : []
})
